import { SET_SET_SETTINGS } from '../_types';
import { func } from '../../helpers';

export function setSetSettings(key, value) {
    return dispatch => {
        // key === 'settings' && console.log(key, value)
        func.setStorageJson(key, value);
        value && dispatch({ type: SET_SET_SETTINGS, key, value });
    }
};